import React from "react";
import { useNavigate } from "react-router-dom";

function Home() {
  const isAuthenticated = localStorage.getItem("auth") === "true";
  const navigate = useNavigate();

  return (
    <>
    
      <main> 
        {/* Hero Section */}
        <section className="section gradient-banner">
          <div className="shapes-container">
            <div className="shape" data-aos="fade-down-left" data-aos-duration="1500" data-aos-delay="100"></div>
            <div className="shape" data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100"></div>
            <div className="shape" data-aos="fade-up-right" data-aos-duration="1000" data-aos-delay="200"></div>
            <div className="shape" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200"></div>
            <div className="shape" data-aos="fade-down-left" data-aos-duration="1000" data-aos-delay="100"></div>
            <div className="shape" data-aos="fade-down-left" data-aos-duration="1000" data-aos-delay="100"></div>
            <div className="shape" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="300"></div>
            <div className="shape" data-aos="fade-down-right" data-aos-duration="500" data-aos-delay="200"></div>
            <div className="shape" data-aos="fade-down-right" data-aos-duration="500" data-aos-delay="100"></div>
            <div className="shape" data-aos="zoom-out" data-aos-duration="2000" data-aos-delay="500"></div>
            <div className="shape" data-aos="fade-up-right" data-aos-duration="500" data-aos-delay="200"></div>
            <div className="shape" data-aos="fade-down-left" data-aos-duration="500" data-aos-delay="100"></div>
            <div className="shape" data-aos="fade-up" data-aos-duration="500" data-aos-delay="0"></div>
            <div className="shape" data-aos="fade-down" data-aos-duration="500" data-aos-delay="0"></div>
            <div className="shape" data-aos="fade-up-right" data-aos-duration="500" data-aos-delay="100"></div>
            <div className="shape" data-aos="fade-down-left" data-aos-duration="500" data-aos-delay="0"></div>
          </div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 order-2 order-md-1 text-center text-md-left">
                <h1 className="text-white font-weight-bold mb-4">
                  Revolutionize Solar Sales with Smart Quotations & Lead Tracker — <i>Powered by SolarEstimate AI</i>
                </h1>
                <p className="text-white mb-5">
                  SolarEstimate AI helps solar businesses manage leads, create smart quotations, automate follow-ups, and close deals faster—all from one powerful platform.
                </p>
                <a href="#download" className="btn btn-main-md">
                  <img className="img-fluid" src="/front-end/images/play.png" style={{height: "40px", width: "40px"}} alt="play button" />
                  Download Now
                </a>
              </div>
              <div className="col-md-6 text-center order-1 order-md-2">
                <img className="img-fluid" src="/front-end/images/solarh.png" alt="Solar application screenshot" />
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="section pt-0 position-relative pull-top">
          <div className="container">
            <div className="rounded shadow p-3 bg-white">
              <div className="row">
                <div className="col-lg-4 col-md-6 mt-5 mt-md-0 text-center">
                  <i className="ti-user h1" style={{color: "#452d80"}}></i>
                  <h3 className="mt-4 text-capitalize h5">Lead Management</h3>
                  <p className="regular text-muted">
                    Capture, assign, and track solar inquiries from one dashboard. Real-time lead status and follow-up tools help convert more solar prospects into paying customers.
                  </p>
                </div>
                <div className="col-lg-4 col-md-6 mt-5 mt-md-0 text-center">
                  <i className="ti-timer h1" style={{color: "#452d80"}}></i>
                  <h3 className="mt-4 text-capitalize h5">Automated Followups</h3>
                  <p className="regular text-muted">
                    Automatically schedule site visits and follow-up calls. Boost solar conversion rates with smart reminders—no more missed opportunities or cold leads.
                  </p>
                </div>
                <div className="col-lg-4 col-md-12 mt-5 mt-lg-0 text-center">
                  <i className="ti-write h1" style={{color: "#452d80"}}></i>
                  <h3 className="mt-4 text-capitalize h5">Smart Quotation Workflow</h3>
                  <p className="regular text-muted">
                    Generate branded solar quotations with GST, subsidy details, and payment terms. Send instantly via WhatsApp or email and track client engagement in real-time.
                  </p>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-lg-12 text-right">
                  <a href="#features" className="btn rounded-pill px-4" style={{color: "#452d80", border: "2px solid #452d80", backgroundColor: "transparent"}}>
                    More Features
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Clients Section */}
        <section className="section clients bg-gray">
          <div className="container">
            <div className="row">
              <div className="col-10 m-auto text-center">
                <h2>Our Clients</h2>
                <div className="client-slider">
                  <div className="item mb-4">
                    <img className="m-auto" src="/front-end/images/greeninfra.png" alt="Green Infrastructure" />
                  </div>
                  <div className="item mb-4">
                    <img className="m-auto" src="/front-end/images/sam.png" alt="SAM Energy" style={{height: "100px", width: "100px"}} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Feature Showcase Section 1 */}
        <section className="feature section pt-0">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 ml-auto justify-content-center">
                <div className="image-content" data-aos="fade-right">
                  <img className="img-fluid" src="/front-end/images/feature/quatation.jpg" alt="Quotation feature" />
                </div>
              </div>
              <div className="col-lg-6 mr-auto align-self-center">
                <div className="feature-content">
                  <h2>Increase your productivity with Solar Apps</h2>
                  <p className="desc">
                    Boost your productivity effortlessly by using simple, focused apps that streamline tasks, automate routines, and keep you organized—helping you get more done in less time.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Feature Showcase Section 2 */}
        <section className="feature section pt-0">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 ml-auto align-self-center">
                <div className="feature-content">
                  <h2>Streamline Your Solar Business</h2>
                  <p>
                    Boost your productivity and simplify your workflow with smart, lightweight apps. From managing leads to sending professional quotations on the go, these tools help automate tasks, reduce effort, and keep you organized—so you can focus on growing your business efficiently.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 mr-auto justify-content-center">
                <div className="image-content" data-aos="fade-left">
                  <img className="img-fluid" src="/front-end/images/feature/fw.png" alt="Framework features" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="service section bg-gray">
          <div className="container-fluid p-0">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title">
                  <h2>An Interface For Lifestyle</h2>
                  <p>Smart Quotation Tools Built for Solar Businesses</p>
                </div>
              </div>
            </div>
            <div className="row no-gutters">
              <div className="col-lg-6 align-self-center">
                <div className="service-thumb left" data-aos="fade-right">
                  <img className="img-fluid" src="/front-end/images/feature/dashboard.png" alt="Dashboard interface" style={{height: "400px", width: "100%", objectFit: "cover"}} />
                </div>
              </div>
              <div className="col-lg-5 mr-auto align-self-center">
                <div className="service-box">
                  <div className="row align-items-center">
                    <div className="col-md-6 col-xs-12">
                      <div className="service-item text-center">
                        <i className="ti-id-badge"></i>
                        <h3><b>Lead Assignment</b></h3>
                        <p>Automatically assign solar inquiries to team members based on service area, panel type, or project size—ensuring timely follow-up and faster conversions.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <div className="service-item text-center">
                        <i className="ti-agenda"></i>
                        <h3><b>Quotation History</b></h3>
                        <p>Maintain a complete log of every solar quote—track revisions, see what's been sent, and revisit older proposals for future upsells or service calls.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <div className="service-item text-center">
                        <i className="ti-ruler-pencil"></i>
                        <h3><b>Custom Quote Templates</b></h3>
                        <p>Create reusable solar quotation formats with branded headers, pre-filled GST, subsidy terms, warranty info, and panel/inverter specs—perfect for speeding up client proposals.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <div className="service-item text-center">
                        <i className="ti-stats-up"></i>
                        <h3><b>Quotation Analytics</b></h3>
                        <p>Analyze which solar quotes are converting best—see trends across panel types, system sizes, and pricing structures to optimize your sales strategy.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="section testimonial" id="testimonial">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h2 className="text-center mb-5">What Our Customers Say</h2>
                <div className="testimonial-slider">
                  <div className="row">
                    <div className="col-md-4 mb-4">
                      <div className="item">
                        <div className="block shadow">
                          <p>
                            "This app has completely streamlined how we manage leads and send quotations. It's fast, clean, and super easy to use—even for non-tech staff."
                          </p>
                          <div className="image">
                            <img src="/front-end/images/testimonial/user.png" alt="Customer testimonial" />
                          </div>
                          <cite>⭐⭐⭐⭐⭐<br />MR. Kishan Pethani</cite>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 mb-4">
                      <div className="item">
                        <div className="block shadow">
                          <p>
                            "A great tool for small teams. The ability to send quotations directly via WhatsApp and track follow-ups makes it ideal for service businesses."
                          </p>
                          <div className="image">
                            <img src="/front-end/images/testimonial/user.png" alt="Customer testimonial" />
                          </div>
                          <cite>⭐⭐⭐⭐⭐<br />Mr. Mahipal Sojitra</cite>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 mb-4">
                      <div className="item">
                        <div className="block shadow">
                          <p>
                            "Super helpful! The lead dashboard gives me a clear picture of who to follow up with. Perfect for keeping my sales pipeline healthy."
                          </p>
                          <div className="image">
                            <img src="/front-end/images/testimonial/user.png" alt="Customer testimonial" />
                          </div>
                          <cite>⭐⭐⭐⭐⭐<br />MR. Sharad Dhameliya</cite>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mb-4">
                      <div className="item">
                        <div className="block shadow">
                          <p>
                            "Impressive for such a lightweight app. I can manage everything on the go—from assigning leads to sending follow-ups. Very practical!"
                          </p>
                          <div className="image">
                            <img src="/front-end/images/testimonial/user.png" alt="Customer testimonial" />
                          </div>
                          <cite>⭐⭐⭐⭐⭐<br />Mr. Sanjay Gondaliya</cite>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 mb-4">
                      <div className="item">
                        <div className="block shadow">
                          <p>
                            "Mobile interface is valuable for architects doing site visits or on-field discussions. Real-time editing helps during client negotiations."
                          </p>
                          <div className="image">
                            <img src="/front-end/images/testimonial/user.png" alt="Customer testimonial" />
                          </div>
                          <cite>⭐⭐⭐⭐⭐<br />Ms. Kavita Hirapra (Interior Designer)</cite>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 mb-4">
                      <div className="item">
                        <div className="block shadow">
                          <p>
                            "For offices with multiple staff — an admin + staff model with synced access and role-based permissions is great."
                          </p>
                          <div className="image">
                            <img src="/front-end/images/testimonial/user.png" alt="Customer testimonial" />
                          </div>
                          <cite>⭐⭐⭐⭐⭐<br />Ms. Ankit Poker (Architecture Designer)</cite>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section className="call-to-action-app section bg-blue" id="download">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center">
                <h2>It's time to change your mind</h2>
                <p>
                  Download our solar management app and get started for free!
                  <br />Transform your solar business today.
                </p>
                <ul className="list-inline">
                  <li className="list-inline-item">
                    <a 
                      href="https://play.google.com/store/apps/details?id=com.qestimate.app" 
                      className="btn btn-rounded-icon"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="ti-android"></i>
                      Android
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </main>
     
    </>
  );
}

export default Home;